<template>
    <div>
        <v-card>
            <v-card-title class="text-h4">Check In</v-card-title>
            <v-card-subtitle v-if='getAccount.lastCheckedInDate != null' class="text-h6">Last Checked-in:&nbsp;{{
                    moment(getAccount.lastCheckedInDate).fromNow()
            }}<br>
                At club:&nbsp;{{ LastCheckedInSiteName }}</v-card-subtitle>
            <v-card-text>
                <span v-if="(noLocation && isSafari) || !noLocation">Please select a site to check-in to. Checking in will use your location, you
                    MUST enable
                    location when prompted to continue check-in.</span>

                <span v-if="noLocation && !isSafari" style="color:red;"> You have blocked your location. Follow the steps bellow to
                    re-enable it:
                    <ol class="pt-2">
                        <li>Click the padlock/pin-point icon to the left of the url. (Browser dependant)</li>
                        <li>Toggle location to true, in the dropdown</li>
                        <li>'REFRESH the page'</li>
                    </ol>
                    <v-spacer class="pt-2"></v-spacer>
                    Once these steps have been completed navigate back to this page and try again. If you still cannot
                    enable location, you will need to enable it in your device settings.
                </span>

                <v-spacer></v-spacer>
                <v-spacer class="pa-2"></v-spacer>
                <v-select filled dense label="Choose Site" v-model="selectedSite" :items="getSites"
                    item-text="sitename">
                </v-select>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click="SubmitCheckIn" class="float-right"
                    :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Check-In</v-btn>
            </v-card-actions>
        </v-card>
        <ConfirmAlert ref="confirm" />
    </div>
</template>

<script>
import RestResource from '../RestResource.js';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import ConfirmAlert from './ConfirmAlert.vue';
import browserDetect from "vue-browser-detect-plugin";
const restResourceService = new RestResource();
export default {
    name: "PushNotification",
    components: { ConfirmAlert },
    Plugin:{browserDetect},
    props: {
        sites: Array
    },
    data() {
        return {
            selectedSite: null,
            dialogTitle: "",
            dialogMessage: "",
            isDialogOpen: false,
            LastCheckedInSiteName: "None",
            noLocation: false,
            isSafari: false,
        };
    },
    beforeMount() {
       
        console.log("NAVIAGOTOR AAGENT: " ,this.$browserDetect)
        if (this.$browserDetect.isSafari || this.$browserDetect.isIOS) this.isSafari = true; else this.isSafari = false;
        console.log("isSafari" + this.isSafari);
    },
    async mounted() {
        try {
            this.location = await this.getLocation();
            this.gettingLocation = false;
            this.noLocation = false;
        }
        catch (e) {
            this.gettingLocation = false;
            this.noLocation = true;
            return this.$emit('snack', "Location is not enabled")
        }
    },
    watch: {
        getAccount: {
            handler(account) {
                if (account != null && this.getSites != null)
                    this.setLastCheckedInSiteName();
            }
        },
        getSites: {
            handler(sites) {
                if (sites != null && this.getAccount != null)
                    this.setLastCheckedInSiteName();
            }
        }
    },
    computed: {
        canGeoLocate() {
            console.log("Computed can locate", !!navigator.geolocation)
            return !!navigator.geolocation
        },
        ...mapGetters([
            "getAccount",
            "getSites",
        ])
    },

    methods: {
        ...mapActions([
            "fetchAccount",
            "fetchAccountBalance",
        ]),
        async getLocation() {
            return new Promise((resolve, reject) => {
                if (!("geolocation" in navigator)) {
                    reject(new Error("Geolocation is not available."));
                }
                navigator.geolocation.getCurrentPosition(pos => {
                    resolve(pos);
                }, err => {
                    reject(err);
                });
            });
        },
        setLastCheckedInSiteName() {
            this.getSites.forEach(element => {
                if (element.id == this.getAccount.lastSiteCheckIn)
                    this.LastCheckedInSiteName = element.sitename;
            });
        },
        async SubmitCheckIn() {
            //Check checked-in in the last 10 hours
            let lastCheckInDate = moment(this.getAccount.lastCheckedInDate);
            let now = moment();
            console.log("   DIFF", Math.abs(lastCheckInDate.diff(now, "hours")))
            if (Math.abs(lastCheckInDate.diff(now, "hours")) < 10) {
                //pop up dialog 
                this.isDialogOpen = true;
                this.dialogTitle = "Checked in already"
                this.dialogMessage = "You last checked in to " + this.LastCheckedInSiteName + " " + lastCheckInDate.fromNow() + ". Are you sure you want to check in again?";

                //Confirm Dialog
                const check = await this.$refs.confirm.open(
                    this.dialogTitle,
                    this.dialogMessage,
                ).catch(err => {
                    console.log(err);
                })
                //If dismiss then don't continue
                if (!check)
                    return;
            }
            //Only get location for none safari browsers
            let latitude;
            let longitude;
            
                //Get Location 
                this.gettingLocation = true;
                try {
                    this.location = await this.getLocation();
                    latitude = this.location.coords.latitude;
                    longitude = this.location.coords.longitude;
                    this.gettingLocation = false;
                    this.noLocation = false;
                }
                catch (e) {
                    if (this.isSafari) {
                        latitude = -1.11111;
                        longitude = -1.11111;
                    }else{
                        return this.$emit('snack', "Location is not enabled")
                    }
                    this.gettingLocation = false;
                    this.noLocation = true;
                }
            
            //Get Site
            let chosenSiteId;
            if (this.selectedSite === null)
                return this.$emit("snack", "Please select a site");
            this.sites.forEach(el => {
                if (el.sitename == this.selectedSite)
                    chosenSiteId = el.id;
            });
            //Build check in object
            const checkInObj = {
                siteId: chosenSiteId,
                latitude: latitude,
                longitude: longitude,
            };
            //Post to backend
            const resStatus = await restResourceService.getPartnerCheckin(checkInObj);
            //Emit result to check in page
            if (resStatus == 200) {
                this.fetchAccount();
                this.$emit("snack", "Successfully Checked Into " + this.selectedSite);
                this.$emit("result", true);
            }
        },
    },
}
</script>
